module.exports = __webpack_public_path__ + "img/vu.e96192d9.svg";